<template>
  <img v-if='this.initialFile' ref='img' :src="this.initialFile.picture ? this.initialFile.picture.url : ''">
</template>

<script>
export default {
  name: 'we-file',
  props: {
    initialFile: {
      type: Object,
      required: false
    }
  },
  mounted: function () {
    this.previewImage(this.$props.initialFile.previewFile)
    this.loading = this.$props.initialFile.loading
  },
  watch: {
    'initialFile.loading': function (newVal, oldVal) {
      this.loading = newVal
    },
    'initialFile.previewImage': function (newVal, oldVal) {
      this.previewImage(newVal)
    }
  },
  methods: {
    previewImage (file) {
      if (file) {
        var reader = new FileReader()
        reader.onload = (e) => {
          if (this.$refs.img) {
            this.$refs.img.src = e.target.result
          }
        }
        reader.readAsDataURL(file)
      }
    }
  },

  data: function () {
    return (
      {
        loading: false
      }
    )
  }
}
</script>
